import { render } from "./Priority.vue?vue&type=template&id=7ac08009"
import script from "./Priority.vue?vue&type=script&lang=js"
export * from "./Priority.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__